@if (interaction(); as interaction) {
  @let createdByUser = interaction?.createdByUser;
  <div [class.table-style]="tableStyle()" class="work-ui-timeline__item">
    <div class="work-ui-timeline__item-badge">
      <div
        [ngClass]="{'success' : interaction.endtime && interaction.interactiontypeId === 3, 'todo' : !interaction.endtime && interaction.interactiontypeId === 3}"
        class="work-ui-timeline__item-badge-icon">
        @if (interaction.interactiontypeId === 2) {
          <work-ui-icon [fontSize]="tableStyle() ? 18 : 24"
                        [name]="interaction.activitytypeId | getActivitytypeIcon" />
        } @else {
          <work-ui-icon [fontSize]="tableStyle() ? 18 : 24"
                        [name]="interaction.interactiontypeId | getInteractiontypeIcon" />
        }
      </div>
    </div>
    <div class="work-ui-timeline__item-body">
      <div class="work-ui-timeline__item__meta flex gap-48 space-between">
        <div class="flex flex-row vertical-center gap-8">
          @if (createdByUser && !tableStyle()) {
            <work-ui-avatar
              [imgSrc]="createdByUser && createdByUser.userImage ? (createdByUser.userImage.fileSrcThumbnail | prependServerToFileSrc) : null"
              [size]="'mini'" />
          }
          <div [class.flex-row]="tableStyle()" class="flex flex-column gap-4">
            <div>
              <small
                class="work-text-color-light work-text-size-micro">{{ interaction.created | formatDate: 'DD.MM.YYYY, HH:mm [Uhr]' }}</small>
            </div>
            <p>
              @if (createdByUser) {
                <a
                  [routerLink]="'/mitarbeiter/details/' + interaction.createdBy"><b>{{ createdByUser.firstName }} {{ createdByUser.lastName }}</b></a>&nbsp;
              }
              @if (!tableStyle()) {
                <span [innerHTML]="(createdByUser ? 'TIMELINE_HAT_X_ERSTELLT' : 'TIMELINE_X_ERSTELLT') | translate: { type: interaction.interactiontype?.name ?? '' }"></span>@if (interaction.interactiontypeId === 2 && interaction.activitytype) {
                  <b>
                    {{ '(' + interaction.activitytype.name + (interaction.outcometype ? (' - ' + interaction.outcometype.name) : '') + ')' }}
                  </b>
                }
              }
            </p>
          </div>
        </div>
      </div>
      @if (isTask) {
        <div [class.flex-row]="tableStyle()"
             class="work-ui-timeline__item__task note task flex flex-column gap-4 margin-top-8">
          <p><b>{{ (interaction.interactiontypeId !== 1 && interaction.subject) ? interaction.subject : '' }}</b>
          </p>
          <p
            class="flex flex-row vertical-center">
            @if (interaction.interactiontypeId === 3 && !interaction.endtime) {
              <small>{{ 'ERLEDIGEN' | translate }}</small>
            }
            @if (interaction.duetime && !interaction.endtime) {
              <small>&nbsp;{{ 'BIS_MIN' | translate }} {{ interaction.duetime | formatDate }}</small>
            }
            @if (interaction.endtime) {
              <small>{{ 'ERLEDIGT_AM' | translate }} {{ interaction.endtime | formatDate }}</small>
            }

            @if (interaction.assignee && !interaction.endtime) {
              <small>&nbsp;{{ 'VON_MIN' | translate }}
                <a
                  [routerLink]="'/mitarbeiter/details/' + interaction.assigneeId">{{ interaction.assignee.firstName }} {{ interaction.assignee.lastName }}</a>
              </small>
            }
            @if (interaction.endtime && interaction?.modifiedByUser) {
              <small>&nbsp;{{ 'VON_MIN' | translate }}
                <a
                  [routerLink]="'/mitarbeiter/details/' + interaction?.modifiedByUser?.id">{{ interaction?.modifiedByUser?.firstName }} {{ interaction?.modifiedByUser?.lastName }}</a>
              </small>
            }
          </p>
        </div>
      }

      @if (interaction.notes) {
        <div class="work-ui-timeline__item__note note flex flex-column gap-12 margin-top-8">
          <p>{{ interaction.notes }}</p>
        </div>
      }
    </div>
  </div>
}
